// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3L0Gt","requiredAsterisk":"Info_requiredAsterisk__1M00Z"};